import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_hvs7bvjf8e: FaireCollectionEntity = {
  token: "pbc_hvs7bvjf8e",
  type: "collection",
  name: "Organic Baby Sleep Gowns & Sleep Sacks",
  heroImageUrl:
    "https://cdn.faire.com/fastly/977bc32b8630d36d5058758b241de81c85dddb0a46baed9762bb92f1afbbad77.jpeg",
  itemCount: 9,
  description:
    "Designed for sleepy cuddles and midnight ease, our breathable organic sleep gowns & sacks offer cozy comfort from newborn snuggles to sweet dreams.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:21.988Z",
    importedBy: "entity-db-import-collections",
  },
};
